import React, { forwardRef } from 'react';
import MuiGrid, { GridSize as MuiGridSize, GridSpacing as MuiGridSpacing, GridTypeMap } from '@material-ui/core/Grid';
import { Uds } from '../../types';

export type GridProps = Uds<GridTypeMap['props'] & { style?: React.CSSProperties; className?: string }>;
export type GridSize = MuiGridSize;
export type GridSpacing = MuiGridSpacing;

export const Grid = forwardRef<HTMLDivElement, React.PropsWithChildren<GridProps>>(({ dataTest, ...props }, ref) => (
  <MuiGrid data-test={dataTest} {...props} ref={ref} />
));
